(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-reviews-hub"] && !Shopify.designMode) return;
  try {
    
function setupReviewHub(){
  document.querySelectorAll('[data-review-hub]').forEach(hub=>{
    const list=hub.querySelector('[data-review-rows]'),source=hub.querySelector('[data-review-list-source]');
    if(!list||!source||list.dataset.ready)return;
    list.dataset.ready='true';
    source.content.querySelectorAll('.jdgm-carousel-item').forEach(item=>{
      const row=document.createElement('article');row.className='rc-rh__review-row';
      const meta=document.createElement('div');meta.className='rc-rh__review-meta';
      const name=document.createElement('span');name.className='rc-rh__review-name';
      name.textContent=item.querySelector('.jdgm-carousel-item__reviewer-name')?.textContent?.trim()||'';
      const rating=item.querySelector('.jdgm-carousel-item__review-rating');
      const score=Math.max(0,Math.min(5,Number.parseFloat(rating?.getAttribute('aria-label')||'0')||0));
      const stars=document.createElement('span');stars.className='rc-rh__review-stars';
      stars.textContent='★'.repeat(Math.round(score))+'☆'.repeat(5-Math.round(score));
      stars.setAttribute('aria-label',score+' / 5');
      meta.append(name,stars);row.append(meta);
      const titleText=item.querySelector('.jdgm-carousel-item__review-title')?.textContent?.trim()||'';
      const bodyText=item.querySelector('.jdgm-carousel-item__review-body')?.textContent?.trim()||'';
      if(titleText&&titleText!==bodyText){const title=document.createElement('h3');title.textContent=titleText;row.append(title);}
      if(bodyText||titleText){const body=document.createElement('p');body.textContent=bodyText||titleText;row.append(body);}
      list.append(row);
    });
  });
}
setupReviewHub();document.addEventListener('shopify:section:load',setupReviewHub);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-photo-wall"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('real-photo-wall')) {
    class RealPhotoWall extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';
        this.dialog = this.querySelector('[data-real-photo-dialog]');
        this.dialogImage = this.querySelector('[data-real-photo-dialog-image]');
        this.track = this.querySelector('[data-real-photo-track]');
        this.previousButton = this.querySelector('[data-real-photo-scroll="previous"]');
        this.nextButton = this.querySelector('[data-real-photo-scroll="next"]');

        this.addEventListener('click', (event) => {
          const scrollButton = event.target.closest('[data-real-photo-scroll]');
          if (scrollButton) {
            this.scrollPhotos(scrollButton.dataset.realPhotoScroll);
            return;
          }

          const trigger = event.target.closest('[data-real-photo-trigger]');
          if (trigger) {
            this.openPhoto(trigger);
            return;
          }

          if (event.target.closest('[data-real-photo-close]')) {
            this.closePhoto();
          }
        });

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closePhoto();
        });

        this.dialog.addEventListener('close', () => {
          this.dialogImage.removeAttribute('src');
          this.dialogImage.alt = '';
        });

        this.track.addEventListener('scroll', () => this.updateControls(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.updateControls());
        this.resizeObserver.observe(this.track);
        this.updateControls();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      transition(callback) {
        if (document.startViewTransition) {
          document.startViewTransition(callback);
          return;
        }
        callback();
      }

      openPhoto(trigger) {
        this.dialogImage.src = trigger.dataset.imageUrl;
        this.dialogImage.alt = trigger.dataset.imageAlt;
        this.transition(() => this.dialog.showModal());
      }

      closePhoto() {
        if (!this.dialog.open) return;
        this.transition(() => this.dialog.close());
      }

      scrollPhotos(direction) {
        const distance = this.track.clientWidth * 0.9;
        const multiplier = direction === 'next' ? 1 : -1;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.track.scrollBy({
          left: distance * multiplier,
          behavior: reducedMotion ? 'auto' : 'smooth',
        });
      }

      updateControls() {
        const maximumScroll = this.track.scrollWidth - this.track.clientWidth;
        this.previousButton.disabled = this.track.scrollLeft <= 2;
        this.nextButton.disabled = this.track.scrollLeft >= maximumScroll - 2;
      }
    }

    customElements.define('real-photo-wall', RealPhotoWall);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reelcute-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rc-hero-slideshow')) {
  customElements.define('rc-hero-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.pages = [...this.querySelectorAll('[data-page]')];
      this.pauseButton = this.querySelector('[data-pause]');
      if (this.slides.length < 2) { this.querySelector('.rc-slides__controls').hidden = true; return; }
      this.slides.forEach((slide,i)=>slide.setAttribute("aria-label", `${i+1} / ${this.slides.length}`));
      this.index = 0;
      this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pages.forEach((button, index) => button.addEventListener('click', () => { this.show(index); this.schedule(); }, options));
      this.querySelectorAll('[data-direction]').forEach(button => button.addEventListener('click', () => { this.show((this.index + Number(button.dataset.direction) + this.slides.length) % this.slides.length); this.schedule(); }, options));
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.updatePause(); this.schedule(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered=true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered=false; this.schedule(); }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => setTimeout(() => this.schedule(), 0), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.updatePause();
      this.schedule();
    }
    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => { slide.inert = i !== index; slide.setAttribute('aria-hidden', String(i !== index)); });
      this.pages.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }
    updatePause() { this.pauseButton.textContent = this.paused ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel; }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.paused || this.hovered || this.contains(document.activeElement) || document.hidden) return;
      this.timer = setTimeout(() => { this.show((this.index + 1) % this.slides.length); this.schedule(); }, 7000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reelcute-popup"]) return;
  try {
    
  (() => {
    const toast = document.getElementById('rc-cart-toast');
    const live = document.getElementById('rc-cart-live');
    let toastTimer;

    const cleanLegacyLinks = () => {
      document.querySelectorAll('a[href*="/collections/early-access"]').forEach((link) => {
        link.href = '/collections/all';
        const text = link.textContent.trim();
        if (/shop the first drop|get early access|join the waitlist/i.test(text)) link.textContent = live?.dataset.shopAll || '';
      });
      document.querySelectorAll('h1, h2, h3, p, span, a').forEach((element) => {
        if (element.children.length) return;
        const text = element.textContent.trim();
        if (/^first-drop looks$/i.test(text)) element.textContent = live?.dataset.featured || '';
        else if (/early access|first[ -]drop|waitlist/i.test(text)) {
          if (element.matches('a, button')) element.textContent = live?.dataset.shopAll || '';
          else if (element.matches('h1, h2, h3')) element.textContent = live?.dataset.listHeading || '';
          else element.textContent = live?.dataset.listCopy || '';
        }
      });
    };

    const normalizeStoreCopy = () => {
      const shipping = live?.dataset.shipping || '';
      const refund = live?.dataset.refund || '';
      const letterCopy = live?.dataset.letters || '';
      const walker = document.createTreeWalker(document.querySelector('main') || document.body, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach((node) => {
        const value = node.nodeValue || '';
        let updated = value
          .replace(/please allow about 1 week before it ships\.?/gi, shipping)
          .replace(/(?:please allow\s*)?3\s*[–—-]\s*4 weeks(?: total)?\.?/gi, shipping)
          .replace(/fully refundable any time before your order ships\.?/gi, refund);
        if (location.pathname === '/pages/how-to-make-it' && /full\s+a\s*[–—-]\s*z\s+(?:letters|alphabet)/i.test(updated)) updated = letterCopy;
        if (updated !== value) node.nodeValue = updated;
      });
      if (location.pathname === '/pages/how-to-make-it') {
        document.querySelectorAll('main img').forEach((image, index) => {
          if (!image.alt || /kit|letter|make|badge reel/i.test(image.alt)) image.alt = `${live?.dataset.howToAlt || ''} ${index + 1}`.trim();
        });
      }
    };

    const getVariantMap = () => {
      const element = document.getElementById('rc-variant-media-map');
      if (!element) return {};
      try {
        return JSON.parse(element.textContent);
      } catch {
        return {};
      }
    };

    const selectedVariantId = () => {
      const checked = document.querySelector('variant-picker input[type="radio"]:checked');
      return checked?.dataset.variantId || document.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    };

    const selectVariantMedia = () => {
      const mapping = getVariantMap()[selectedVariantId()];
      if (!mapping?.mediaId) return;
      const media = document.querySelector(`media-gallery [data-media-id="${mapping.mediaId}"]`);
      const slide = media?.closest('slideshow-slide');
      const slideshow = slide?.closest('slideshow-component');
      if (!slide || !slideshow) return;
      const slides = Array.from(slideshow.querySelectorAll(':scope > .slideshow__slides > slideshow-slide, :scope slideshow-slide[ref="slides[]"]'));
      const index = slides.indexOf(slide);
      if (index >= 0 && typeof slideshow.select === 'function') slideshow.select(index, undefined, { animate: false });
      const image = media.querySelector('img');
      const stickyImage = document.querySelector('.sticky-add-to-cart__image-img');
      if (image && stickyImage) {
        stickyImage.src = image.currentSrc || image.src;
        stickyImage.srcset = image.srcset;
        stickyImage.alt = image.alt;
      }
    };

    const announce = (message) => {
      if (!live) return;
      live.textContent = '';
      requestAnimationFrame(() => {
        live.textContent = message;
      });
    };

    const showToast = () => {
      if (!toast) return;
      const map = getVariantMap();
      const variant = map[selectedVariantId()] || {};
      const activeImage = document.querySelector('media-gallery slideshow-slide[aria-hidden="false"] img');
      const title = document.querySelector('.product-information h1, main h1')?.textContent?.trim() || '';
      const image = toast.querySelector('.rc-cart-toast__image');
      if (image && activeImage) {
        image.src = activeImage.currentSrc || activeImage.src;
        image.alt = activeImage.alt || title;
      }
      toast.querySelector('.rc-cart-toast__title').textContent = title;
      toast.querySelector('.rc-cart-toast__variant').textContent = variant.title || '';
      toast.querySelector('.rc-cart-toast__price').textContent = variant.price || '';
      toast.hidden = false;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(() => {
        toast.hidden = true;
      }, 8000);
    };

    const handleCartUpdate = (event) => {
      if (event.detail?.data?.source !== 'product-form-component') return;
      if (event.detail?.data?.didError) {
        announce(event.detail?.resource?.description || event.detail?.resource?.message || live?.dataset.error || '');
        return;
      }
      announce(live?.dataset.added || '');
      requestAnimationFrame(() => {
        const drawer = document.querySelector('cart-drawer-component');
        const dialog = drawer?.querySelector('dialog');
        if (dialog?.open) return;
        if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
        setTimeout(() => {
          if (!dialog?.open) showToast();
        }, 400);
      });
    };

    const updateKeyboardState = () => {
      if (!window.visualViewport) return;
      document.body.classList.toggle('rc-keyboard-open', window.visualViewport.height < window.innerHeight * 0.72);
    };

    cleanLegacyLinks();
    normalizeStoreCopy();
    let legacyCleanupTimer;
    const legacyObserver = new MutationObserver(() => {
      clearTimeout(legacyCleanupTimer);
      legacyCleanupTimer = setTimeout(cleanLegacyLinks, 60);
    });
    legacyObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => legacyObserver.disconnect(), 10000);
    selectVariantMedia();

    document.addEventListener('variant:update', () => requestAnimationFrame(selectVariantMedia));
    document.addEventListener('change', (event) => {
      if (event.target.closest?.('variant-picker')) requestAnimationFrame(selectVariantMedia);
    });
    document.addEventListener('cart:update', handleCartUpdate);
    window.addEventListener('popstate', () => setTimeout(selectVariantMedia, 100));
    window.visualViewport?.addEventListener('resize', updateKeyboardState);

  })();

  } catch(e) { console.error(e); }
})();
})();
